import * as React from "react"
import Seo from "../components/seo"
import ContentPageLayout from "../components/ContentPageLayout"
import ContentSkeleton from "../components/ContentSkeleton"
import { getHome } from "../api/content"
import Section from "../components/content/section";
import firebase from "firebase";
import config, { firebaseInit } from "../config"

const IndexPage = ({ location }) => {
  const profileUri = config.serverUri
  const [contentLoading, setContentLoading] = React.useState(true)
  const [section, setSection] = React.useState()
  const [userHasSuscription, setUserHasSuscription] = React.useState(null)

  React.useEffect(() => {
    getHome().then(data => {
      setSection(data)
      setContentLoading(false)
    })
  }, [])

  React.useEffect(() => {
    firebaseInit(firebase)
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        fetch(`${profileUri}/users?email=${user.email}`)
          .then(response => {
            if (response) {
              response.json().then(dataUser => {
                setUserHasSuscription(dataUser[0].suscription)
              })
            }
          }).catch(error => {
            console.log(error)
          }).catch(error => {
            console.log(error)
          })
      } else {
        console.log("user is null")
        setUserHasSuscription(false)
      }
    })
  }, [])


  return (<ContentPageLayout location={location}>
    <Seo title="Home" />
    {contentLoading || !section ? <ContentSkeleton></ContentSkeleton> : <Section key={section._id} section={section} userHasSuscription={userHasSuscription ?? null}></Section>}
  </ContentPageLayout>)
}

export default IndexPage
